import { render, staticRenderFns } from "./ModalConfirmRegistration.vue?vue&type=template&id=7a34f538&scoped=true&"
import script from "./ModalConfirmRegistration.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmRegistration.vue?vue&type=style&index=0&id=7a34f538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a34f538",
  null
  
)

export default component.exports